"use client";

import Link from "next/link";
import { useState, useEffect } from "react";
import { usePathname,useRouter } from "next/navigation";
import  Image from "next/image";
import { X, AlignRight } from "lucide-react";
import { motion  } from 'framer-motion';
import {  ChevronDown  } from 'lucide-react';
import link from '@/lib/localEndPoints'

import { useFetchSWR, useFetchSWRInfinite } from '@/lib/swrConfig';
import endPoints from '@/lib/apiEndPoints'
import {ParentCompanyData} from '@/types/companies'
import { BlogData } from "@/types/blogs";
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  
  // Fetch notices using SWR
  const {data: notices } = useFetchSWR(endPoints.NOTICES);
  const {data: companiesRes } = useFetchSWR(endPoints.COMPANIES( 1, 20));
  const companies= companiesRes?.status === 200 ? companiesRes.data : [];

  // get parrent company details
  const { data: comRes } = useFetchSWR(endPoints.PARRENT_COMPANY);
  const company: ParentCompanyData = comRes?.status === 200 ? comRes.data : {};

  // get lates news updates and blogs
  const getNews = (pageIndex: number, previousPageData: any) => {
    if (previousPageData && !previousPageData.data.length) return null;
        return endPoints.BLOGS(pageIndex + 1, 3);
    };
  const { data: newsData } = useFetchSWRInfinite(getNews);
  const newses = newsData ? newsData.flatMap((page) => page.data) : [];

  const router = useRouter();
  const pathname = usePathname();
  // notice bar show hide on scroll
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // Check if current route is inside /our-companies
  const isActive = pathname.startsWith("/our-companies");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    
  }, []);

  // Handlers
  const handleMouseEnter = () => {
    if (!isMobile) setOpen(true);
  };
  const handleMouseLeave = () => {
    if (!isMobile) setOpen(false);
  };
  const handleClick = (e: React.MouseEvent) => {
    if (isMobile) {
      e.preventDefault(); // Prevent immediate navigation
      setOpen((prev) => !prev);
    }
  };

  // Company dropdown url
  
    const handleServiceClick = (slug: string) => {
        const targetPath = `${link.COMPANIES}/${slug}`

        if (pathname !== targetPath) {
            router.push(targetPath)
        }

        }

  const toggleMenu = () => setIsOpen(!isOpen);

  // notice bar animation
  const noticesList = Array.isArray(notices?.data) ? notices.data : [];
  const loopedNotices = [...noticesList, ...noticesList];

  // Menu items
  const menuItems = [
    { name: "Home", href: link.HOME },
    { name: "About us", href: link.ABOUT },
    { name: "News & Updates", href: link.NEWS },
    { name: "Events", href: link.EVENT },
    { name: "CSR", href: link.SOCIAL },
    { name: "Career", href: link.CAREER },
  ];

  return (
    <>
      <nav className="bg-background shadow-sm sticky top-0  z-50">
        <div className="container h-[70px] md:h-[80px] lg:h-[60px] flex justify-between items-center ">
          {/* Logo */}
          <div className="flex items-center space-x-2 xl:space-x-4">
            <div className="w-16 h-16 md:w-18 md:h-18 lg:w-14 lg:h-14">
              <Link rel="preload" href={link.HOME}  prefetch className="relative ">
                <Image
                  src={company?.media?.[0]?.url || "/logo.png"}
                  alt="logo"
                  width={100}
                  height={100}
                  className="object-contain "
                />
              </Link>
            </div>

            {/* Desktop Menu */}
              {
                !isMobile && (
                  <div className="hidden lg:flex md:space-x-4  xl:space-x-6">
                    {menuItems.map((item) => (
                      <Link
                        rel="preload"  prefetch
                        key={item.href}
                        href={item.href}
                        className={`transition font-medium cursor-pointer ${
                          pathname === item.href || pathname.startsWith(item.href + "/")
                            ? " text-primary"
                            : "text-gray-700  hover:text-primary hover:underline"
                        }`}
                      >
                        {item.name}
                      </Link>
                    ))}

                    {/* Sister Companies Dropdown */}
                    <div
                      className="relative"
                      onMouseEnter={() => setOpen(true)}
                      onMouseLeave={() => setOpen(false)}
                    >
                      {/* Main link  */}
                      <Link
                        rel="preload"  prefetch
                        href={link.COMPANIES}
                        className={`flex items-center gap-1 font-medium transition-colors ${
                          open || isActive ? "text-primary" : "text-gray-800 hover:text-primary"
                        }`}
                      >
                        Our Companies
                        <ChevronDown
                          className={`h-4 w-4 transition-transform duration-200 ${
                            open ? "rotate-180 text-primary" : ""
                          }`}
                        />
                            </Link>

                      {/* Dropdown */}
                      {open && (
                        <div className="absolute lg:-left-75 xl:-left-50 top-full  w-[700px] bg-white shadow-lg rounded-xl p-4 grid grid-cols-2 gap-2 z-50">
                          {companies.map((company: ParentCompanyData) => (
                            <button
                              onClick={() => handleServiceClick(company.slug)}
                              key={company.slug}
                              
                              className={`block rounded-lg px-3 cursor-pointer py-1 text-gray-700 font-medium hover:bg-blue-50 hover:text-primary hover:underline transition ${
                                pathname == `${link.COMPANIES}/${company.slug}`
                                  ? "bg-blue-50 text-primary font-medium"
                                  : "hover:text-primary"
                              }`}
                            >
                              <div className="flex items-center gap-2  ">
                                
                                  <div className="relative w-10 h-10">
                                    <Image
                                    src={company?.media?.[0]?.url || "/default-logo.png" }
                                    alt={company.name }
                                    fill
                                    className="object-contain rounded-full "
                                />
                                  </div>
                                
                                <span className="text-sm">{company.name}</span>
                              </div>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )
              }
            
          </div>

          {/* Contact Button */}
          {
            !isMobile && (
              <div className="hidden lg:block  ">
                <Link
                  rel="preload"  prefetch
                  href={link.CONTACT}
                  className={`px-5 py-2 rounded-full transition ${
                    pathname === link.CONTACT
                      ? "bg-primary text-white"
                      : "bg-primary text-white hover:bg-prime-hover"
                  }`}
                >
                  Contact
                </Link>
              </div>
            )
          }

          {/* Mobile Menu Button */}
            {
              isMobile && (
                <div className="  ">
                  <button onClick={toggleMenu} className="focus:outline-none cursor-pointer">
                    {isOpen ? (
                      <X className="md:w-8 md:h-8" />
                    ) : (
                      <AlignRight className="md:w-8 md:h-8" />
                    )}
                  </button>
                </div>
              )
            }
        </div>


        {/* Mobile Menu */}
        {isOpen && isMobile && (
          <div className="lg:hidden fixed inset-0 top-17 md:top-20 pb-6 pt-4 space-y-2 bg-primary overflow-y-auto z-50">
            <div className="container">
              {menuItems.map((item) => (
                <Link
                  rel="preload"  prefetch
                  key={item.href}
                  href={item.href}
                  onClick={toggleMenu}
                  className={`block px-4 py-2   transition ${
                    pathname === item.href
                      ? " text-white border-b-2 "
                      : "text-white"
                  }`}
                >
                  {item.name}
                </Link>
              ))}

              {/* Sister Companies Dropdown */}
            <div
                className="relative"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {/* Main link */}
                <Link
                  rel="preload"  prefetch
                  href={link.COMPANIES}
                  onClick={handleClick}
                  className={`px-4 flex items-center gap-1 transition-colors  ${
                    open || isActive ? "text-white" : "text-white"
                  }`}
                >
                  Our Companies
                  <ChevronDown
                    className={`h-5 w-5  transition-transform text-white duration-200 ${
                      open  ? "rotate-180 " : ""
                    }`}
                  />
                </Link>

                {/* Dropdown for mobile menu */}
                {open && (
                  <div className=" min-w-[250px] rounded-xl px-4 mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2 z-50 ">
                    {/* First link = All Companies */}
                    <Link
                      rel="preload"  prefetch
                      href={link.COMPANIES}
                      onClick={toggleMenu}
                      className={`block  px-3 py-1 text-white transition  ${
                        pathname === link.COMPANIES
                          ? "border-b-2"
                          : ""
                      }`}
                    >
                      All Companies
                    </Link>

                    {companies.map((company: ParentCompanyData) => (
                      <button
                        onClick={() => {
                          toggleMenu();
                          handleServiceClick(company.slug);
                        }}
                        key={company.slug}
                        className={`block text-left px-3 py-1 text-white transition md:text-lg ${
                          pathname === `/${company.slug}`
                            ? "border-b-2"
                            : ""
                        }`}
                      >
                        {company.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Contact Button */}
              <Link
                rel="preload"  prefetch
                href={link.CONTACT}
                onClick={toggleMenu}
                className={`block  px-4 py-2   text-white transition ${
                  pathname === link.CONTACT
                    ? "border-b-2  "
                    : ""
                }`}
              >
                Contact
              </Link>
                {/* -- latest news and updates -- */}
                { 
                  newses?.length > 0 && (
                    <div className="mt-6">
                      <h3 className="text-base sm:text-lg font-medium text-white mb-2 sm:mb-4">
                        LATEST NEWS & UPDATE
                      </h3>

                      <div className="flex flex-col ">
                        {newses.map((news: BlogData) => (
                            <Link
                                key={news.id}
                                rel="preload"
                                prefetch
                                onClick={toggleMenu}
                                href={`${link.NEWS}/${news.slug}`}
                                className="flex gap-4 py-4 group border-b-2"
                              >
                                {/* blog image */}
                                <div className="relative overflow-hidden flex-shrink-0 w-24 h-16 sm:w-32 sm:h-20 ">
                                  <Image
                                    src={news.media?.[0]?.url || "/default.jpg"}
                                    alt="News Update Image"
                                    fill
                                    loading="lazy"
                                    className="object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                                    quality={60}
                                  />
                                </div>

                                {/* blog title */}
                                <div className="flex items-center">
                                  <h2 className="text-xs/5 sm:text-sm/5 font-medium text-white line-clamp-2">
                                    {news.title}
                                  </h2>
                                </div>
                              </Link>
                        ))}

                      </div>
                    </div>
                  )
                }

            </div>
          </div>
        )}
      
      </nav>
      
      {/* --- The Notice Ticker Section --- */}
      {loopedNotices?.length > 0 && (
         <div className="w-full h-8 overflow-hidden bg-primary text-background flex items-center">
          <motion.div
            className="flex whitespace-nowrap divide-x-2"
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              duration: 100,
              ease: "linear",
              repeat: Infinity,
            }}
          >
            {loopedNotices.map((notice, idx) => (
              <div
                key={idx}
                className="flex items-center px-6"
              >
                <span className="text-sm md:text-base font-medium">{notice.content}</span>
              </div>
            ))}
          </motion.div>
        </div>
        
      )}
      </>
  );
};

export default Navbar;
